import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { APICallService } from 'src/app/services/api-call.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';

@Component({
  selector: 'coverage-type-lov',
  templateUrl: './coverage-type-lov.component.html',
  styleUrls: ['./coverage-type-lov.component.css']
})
export class CoverageTypeLovComponent implements OnInit {

  private coverageTypeModuleId: string = 'BMM052';
  private selectedData: any;
  public titleLov: string = "Coverage Type".toUpperCase();

  coverageTypeTable: any = {
    cols: [
      {
        key: "COVERAGE_TYPE_CD",
        header: "Coverage Type Code",
        dataType: "string"
      },
      {
        key: "COVERAGE_TYPE_DESC",
        header: "Coverage Type",
        dataType: "string"
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };

  constructor(
    private jsonDataService: JsonDataService,
    private dialogRef: MatDialogRef<CoverageTypeLovComponent>,
    private _api: APICallService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public fromMainData: any,
  ) {
    this.getCoverageTypeData();
  }

  ngOnInit(): void {
  }

  onRowClick(ev: any) {
    try {
      this.selectedData = ev;
    } catch (e) {
      console.error(e);
    }
  }

  private getCoverageTypeData(): void {
    try {
      this.coverageTypeTable.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getCoverageType({
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(data?.response));
              if (content.moduleId === this.coverageTypeModuleId) {
                this.jsonDataService.contorlLoading(false);
                this.coverageTypeTable.tblData = content.data.filter((e: any) => e.ACTIVE_TAG == 'A');
                if (this.fromMainData?.lpad) {
                  this.coverageTypeTable.tblData = this.coverageTypeTable.tblData.map((c: any) => { return { ...c, COVERAGE_TYPE_CD: parseInt(c.COVERAGE_TYPE_CD)?.toString().padStart(this.fromMainData?.lpad ?? 0, "0") } });
                }
                this.coverageTypeTable.loading = false;
              } else {
                this.coverageTypeTable.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {
            console.error(e);
            this.coverageTypeTable.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
    console.error(e);

      this.coverageTypeTable.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }

  onClose(str: string) {
    try {
      if (this.selectedData == '' || this.selectedData == null) {
        this.dialogRef.close({ content: '', button: str });
      }
      else {
        this.dialogRef.close({ content: this.selectedData, button: str });
      }
    } catch (e) {
      console.error(e);
    }
  }

}
